import PropTypes from "prop-types";

import Row from "react-bootstrap/Row";

// const ReturnBackComponent = ({ url, text, image }) => {
const ReturnBackComponent = ({ text, image }) => {
  return (
    <a
      // href={url}
      href="http://www.therecap.io/"
      target={"_blank"}
      className="link-to-the-site fs-14 cursor-pointer"
      rel="noreferrer"
    >
      <Row>
        <img
          src={image}
          width="30"
          height="30"
          className="d-inline-block align-top"
          alt="RegHub logo"
          style={{
            position: "relative",
            bottom: "5px",
          }}
        />
        <span className="link-text">{text}</span>
      </Row>
    </a>
  );
};

ReturnBackComponent.propTypes = {
  // url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
};

ReturnBackComponent.defaultProps = {
  url: "",
  text: "",
  image: <></>,
};

export default ReturnBackComponent;
